module.exports = __webpack_public_path__ + "img/0a7a821111dbf127f123046f38ab3bb1.0a7a8211.png";